<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">

        <div class="card-group">


          <div class="card">

            <div class="card-body">

              <div class="text-center brand-jumbotron">
                <img src="assets/img/brand/logo.svg" class="img-fluid isupplier-logo"
                     alt="iSupplier logo"/>
                <h4 class="login-heading mb-4">{{'reset-password-heading'|translate}}</h4>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div *ngIf="!isSuccess && !isError">

                    <form [formGroup]="resetPasswordForm"
                          (ngSubmit)="resetPasswordFormSubmit()">

                      <div class="form-group">
                        <label for="password" hidden></label>
                        <input class="form-control" id="password" type="password"
                               formControlName="password"
                               placeholder="{{'reset-password.form.password-placeholder'|translate}}"/>
                      </div>

                      <div class="form-group">
                        <label for="confirmPassword" hidden></label>
                        <input class="form-control" id="confirmPassword" type="password"
                               formControlName="confirmPassword"
                               placeholder="{{'reset-password.form.confirmPassword-placeholder'|translate}}"/>
                      </div>

                      <div class="form-group">
                        <app-password-meter
                          [password]="resetPasswordForm.value.password" [numberRequired]="2"
                          (passwordValid)="setPasswordValid($event)"></app-password-meter>
                      </div>

                      <button class="btn btn-primary btn-block font-weight-bold mb-2" type="submit"
                              [disabled]="!(passwordValid && resetPasswordForm.value.password === resetPasswordForm.value.confirmPassword)">
                        <em
                          class="fa fa-key"></em>{{'reset-password.form.button.change-my-password'|translate}}
                      </button>
                    </form>

                  </div>


                  <div class="text-center" *ngIf="isError && !isSuccess">

                    <div class="swal2-icon swal2-error swal2-animate-error-icon"
                         style="display: flex;">
                  <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span
                    class="swal2-x-mark-line-right"></span></span></div>

                    <p class="error-message">
                      {{'reset-password.error-message.text'|translate}}
                      <a
                        [routerLink]="['/forget-password']">{{'reset-password.error-message.page'|translate}}</a>
                    </p>

                    <a class="btn btn-link btn-block  mb-2" [routerLink]="['/login']">
                      {{'return-login'|translate}}
                    </a>

                  </div>

                  <div class="text-center" *ngIf="isSuccess && !isError">

                    <div class="swal2-icon swal2-success swal2-animate-success-icon">
                      <div class="swal2-success-circular-line-left"
                           style="background-color: rgb(255, 255, 255);"></div>
                      <span class="swal2-success-line-tip"></span>
                      <span class="swal2-success-line-long"></span>
                      <div class="swal2-success-ring"></div>
                      <div class="swal2-success-fix"
                           style="background-color: rgb(255, 255, 255);"></div>
                      <div class="swal2-success-circular-line-right"
                           style="background-color: rgb(255, 255, 255);"></div>
                    </div>

                    <p class="success-message">
                      <span><strong>{{'reset-password.success-message.strong'|translate}}</strong> </span>
                      <span>{{'reset-password.success-message.text'|translate}}</span>
                      <span><strong>{{counter$ | async}}</strong></span>
                      <span>{{'reset-password.success-message.seconds'|translate}}</span>
                    </p>

                    <a class="btn btn-primary btn-block  mb-2" [routerLink]="['/login']">
                      {{'return-login'|translate}}
                    </a>

                  </div>


                </div>


              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
